import { useEffect, useState } from "react";
import { Layout } from "antd";

import Header from "Components/Header/Header";
import DocumentBuilder from "Components/Builder/DocumentBuilder";
import AuthBackgroundScreen from "Components/Auth/AuthBackgroundScreen";
import { AuthProvider, useAuth } from "context/AuthContext";

const { Content } = Layout;

function AppContent() {
  const { isAuthenticated, isAuthReady, appAccessDenied, user, logout } = useAuth();
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  // Keep the screen blank (rather than flashing the sign-in card) while MSAL
  // is still figuring out whether an existing session is already active.
  if (!isAuthReady) {
    return <div style={{ height: "100vh", width: "100vw", background: "#12357f" }} />;
  }

  if (appAccessDenied) {
    return <AuthBackgroundScreen accessDenied />;
  }

  if (!isAuthenticated) {
    return <AuthBackgroundScreen />;
  }

  return (
    <Layout style={{ height: "100vh", overflow: "hidden" }}>
      <Header user={user} onLogout={logout} />

      <Content style={{ backgroundColor: "#f5f5f5", overflow: "hidden", padding: "16px 24px", display: "flex", flexDirection: "column" }}>
        <DocumentBuilder />
      </Content>

      <Layout.Footer
        style={{
          zIndex: 100,
          position: "relative",
          textAlign: "center",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "0 20px",
          background: "#160d6c",
          borderTop: "1px solid #e8e8e8",
          height: "28px",
          lineHeight: "28px",
          fontSize: "10px",
          flexShrink: 0,
          color: "white"
        }}
      >
        <div style={{ minWidth: "200px", textAlign: "left" }}>
          {currentTime
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric"
            })
            .toUpperCase()}{" "}
          {currentTime.toLocaleTimeString("en-US")} (GMT
          {(() => {
            const offset = -currentTime.getTimezoneOffset();
            const hours = Math.floor(Math.abs(offset) / 60);
            const minutes = Math.abs(offset) % 60;
            return (offset >= 0 ? "+" : "-") + String(hours).padStart(2, "0") + String(minutes).padStart(2, "0");
          })()}
          )
        </div>
        <div style={{ flex: 1, textAlign: "center" }}>MARS Document Builder | Copyright © 2026 by Quartica | Disclaimer</div>
        <div style={{ minWidth: "200px" }}></div>
      </Layout.Footer>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
